import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, UnitItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-product-multi-unit',
  templateUrl: './product-multi-unit.component.html',
  styleUrls: ['./product-multi-unit.component.css']
})
export class ProductMultiUnitComponent implements OnInit {
    prodId;

    public edit?: Edit;

    public selectListUnits: UnitItem[] = [];

    public selectListProductUnits: ProductUnitItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadEdit() {
        if (!!this.prodId) {
            this.edit = (await this.datatask.Post(1080, { prod_id: this.prodId }))[0];
        }
    }

    private async loadUnits() {
        this.selectListUnits = await this.logistic.getUnitList({ isactive: '1' });
    }

    public async loadProductUnits() {
        if (!this.edit) return;

        this.selectListProductUnits = await this.datatask.Post(580, { prod_id: this.edit.prod_id });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1081, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadUnits();
        this.loadProductUnits();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prod_id: string;
    stock_unit_no: string;
    purch_number_unit_no: string;
    purch_price_unit_no: string;
    sales_price_unit_no: string;
    nbr_of_productunits: string;
    warning_productunit: string;
    prod_stockcount_unit_no: string;
    fpak_unit_no: string;
    dpak_unit_no: string;
    tpak_unit_no: string;
    psepak_unit_no: string;
    heading_pak: string;
}

interface ProductUnitItem {
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    unit_no: string;
    shortname: string;
}
